import { render, staticRenderFns } from "./DashboardSettingsDrawer.vue?vue&type=template&id=38a80ff0"
import script from "./DashboardSettingsDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardSettingsDrawer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports